import { FormTemplateFieldTypes } from 'mapistry-shared';

export const addableFormTemplateFieldTypes: readonly FormTemplateFieldTypes[] =
  [
    FormTemplateFieldTypes.TEXT,
    FormTemplateFieldTypes.TEXT_AREA,
    FormTemplateFieldTypes.NUMBER,
    FormTemplateFieldTypes.DATE,
    FormTemplateFieldTypes.TIME,
    FormTemplateFieldTypes.BOOLEAN,
    FormTemplateFieldTypes.TASKS,

    FormTemplateFieldTypes.SINGLE_SELECT,
    FormTemplateFieldTypes.SINGLE_SELECT_WITH_FREE_FORM,
    FormTemplateFieldTypes.MULTI_SELECT,
    FormTemplateFieldTypes.MULTI_SELECT_WITH_FREE_FORM,
    FormTemplateFieldTypes.USER,
    FormTemplateFieldTypes.SIGNATURE,
    FormTemplateFieldTypes.MULTI_USER,

    /* checkbox in form allows switching to multi location field */
    FormTemplateFieldTypes.SINGLE_LOCATION,

    FormTemplateFieldTypes.DOCUMENT_UPLOADER,
    FormTemplateFieldTypes.PHOTO_CAROUSEL,
    FormTemplateFieldTypes.WEATHER,
    FormTemplateFieldTypes.EMISSION_OBSERVATION,
    FormTemplateFieldTypes.PHONE_NUMBER,
    FormTemplateFieldTypes.EXPLANATION_AREA,
  ];
